const authUrls = {
    fetchAuthOptions: {
        url: '/auth/options'
    },
    loginEkyzmat: {
        url: '/auth/authEkyzmat'
    },
    logout: {
        url: 'auth/logout'
    },
    getRequestUser: {
        url: 'auth/user'
    },
};

export default authUrls;